import beauty from './beauty';
import fashion from './fashion';
import hair from './hair';

export default {
	beauty,
	fashion,
	hair,
};
